import { useEffect, useState } from "react";

import { LabelInput } from "../../../components/Reusable/Layout";
import Modal from "../../../components/Reusable/Modal";
import { Button } from "../../../components/Reusable/Button";
import { Faq } from "../Data/Plans/types";

export interface EditFaqModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreate: (question: string, answer: string) => void;
  faq?: Faq;
}

const EditFAQModal: React.FC<EditFaqModalProps> = ({
  isOpen,
  onClose,
  onCreate,
  faq,
}) => {
  const [currentQuestion, setQuestion] = useState("");
  const [currentAnswer, setAnswer] = useState("");

  const handleCreate = () => {
    if (currentQuestion.trim() && currentAnswer.trim()) {
      onCreate(currentQuestion, currentAnswer);
      setQuestion("");
      setAnswer("");
      onClose();
    }
  };

  useEffect(() => {
    if (faq) {
      setQuestion(faq.question);
      setAnswer(faq.answer);
    }
  }, [faq]);

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleModalClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  if (!isOpen) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
      onClick={handleOverlayClick}
    >
      <div
        className="bg-white dark:bg-[#1E1E1E] rounded-lg p-6 w-full max-w-md shadow-2xl"
        style={{
          boxShadow:
            "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
        }}
        onClick={handleModalClick}
      >
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold dark:text-white">Edit FAQ</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-300 dark:hover:text-white text-2xl"
          >
            &times;
          </button>
        </div>

        <div className="space-y-4">
          <div>
            <LabelInput
              type="text"
              value={currentQuestion}
              placeholder="Question"
              name="Question"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setQuestion(e.target.value)
              }
            />
          </div>

          <div>
            <LabelInput
              type="text"
              value={currentAnswer}
              placeholder="Answer"
              name="Answer"
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setAnswer(e.target.value)
              }
              className="h-40"
            />
          </div>
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-gray-300 dark:border-[#FFFFFF1A] rounded-md text-sm font-medium dark:text-white"
          >
            Cancel
          </button>
          <Button
            onClick={handleCreate}
            type="submit"
            bgColor="bg-gradient-to-r from-[#027EC2] to-[#039EF2]"
            textColor="text-white"
            borderRadius="rounded-lg"
            className="w-[200px] h-10"
          >
            Save Changes
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EditFAQModal;
